export function validateAdminSignIn(fieldValues) {
  const errors = {};
  if ("email" in fieldValues) {
    if (!fieldValues.email) {
      errors.email = "Email is required";
    } else if (
      !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(
        fieldValues.email
      )
    ) {
      errors.email = "Email is not valid";
    }
  }

  if ("password" in fieldValues) {
    if (!fieldValues.password) {
      errors.password = "Password is required";
    } 
  }

  return errors;
}
export function validateAddAdmin(fieldValues, isEdit) {
  const errors = {};
  // Email: required + format
  if ("email" in fieldValues) {
    if (!fieldValues.email) {
      errors.email = "Email is required";
    } else if (
      !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(
        fieldValues.email
      )
    ) {
      errors.email = "Email is not valid";
    }
  }

  // Password: required + length
  if(isEdit===false){
  if ("password" in fieldValues) {
    if (!fieldValues.password) {
      errors.password = "Password is required";
    } else if (fieldValues.password.length < 8) {
      errors.password = "Password must be at least 8 characters";
    }
  }
  }

  // Name: required
  if ("name" in fieldValues) {
    if (!fieldValues.name) {
      errors.name = "Name is required";
    }
  }

  // Role: required, must be 'agent' or 'appAdmin'
  if ("role" in fieldValues) {
    if (!fieldValues.role) {
      errors.role = "Role is required";
    } else if (!["agent", "appAdmin"].includes(fieldValues.role)) {
      errors.role = "Role must be 'agent' or 'appAdmin'";
    }
  }

  // appID: required if role is appAdmin
  if ("appID" in fieldValues) {
    if (fieldValues.role === "appAdmin" && !fieldValues.appID) {
      errors.appID = "appID is required for App Admin";
    }
  }

  return errors;
}
export function validateAddAPP(fieldValues) {
  const errors = {};
  // Email: required + format
  if ("app_name" in fieldValues) {
    if (!fieldValues.app_name) {
      errors.app_name = "App name is required";
    } 
  }

  // Password: required + length
  if ("app_id" in fieldValues) {
    if (!fieldValues.app_id) {
      errors.app_id = "App id is required";
    }
  }
  // Name: required
  if ("app_url" in fieldValues) {
    var httpRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
    if (!fieldValues.app_url) {
      errors.app_url = "App URL is required";
    }
    if(httpRegex.test(fieldValues.app_url) === false){
      errors.app_url = "App URL is not valid";
    }
  }

  // Role: required, must be 'agent' or 'appAdmin'
  if ("payment_method" in fieldValues) {
    if (!fieldValues.payment_method) {
      errors.payment_method = "Payment method is required";
    }
  }



  return errors;
}
export function validateAddGateway(fieldValues) {
  const errors = {};
  // Email: required + format
  if ("gateway_name" in fieldValues) {
    if (!fieldValues.gateway_name) {
      errors.gateway_name = "Gateway name is required";
    } 
  }

  // Password: required + length
  if ("secret_key" in fieldValues) {
    if (!fieldValues.secret_key) {
      errors.secret_key = "Secret key is required";
    }
  }


  // Role: required, must be 'agent' or 'appAdmin'
  if ("publishing_key" in fieldValues) {
    if (!fieldValues.publishing_key) {
      errors.publishing_key = "Publishing key is required";
    }
  }
    if ("mode" in fieldValues) {
    if (!fieldValues.mode) {
      errors.mode = " Mode is required";
    }
  }



  return errors;
}
export function validateAddUserHost(fieldValues) {
  const errors = {};

  // Name: required
  if ("name" in fieldValues) {
    if (!fieldValues.name.trim()) {
      errors.name = "Name is required";
    }
  }

  // Email: required + format
  if ("email" in fieldValues) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!fieldValues.email.trim()) {
      errors.email = "Email is required";
    } else if (!emailRegex.test(fieldValues.email)) {
      errors.email = "Email is not valid";
    }
  }

  // HCode: required
  // if ("hcode" in fieldValues) {
  //   if (!fieldValues.hcode.trim()) {
  //     errors.hcode = "Hcode is required";
  //   }
  // }

  // Gender: required
  if ("gender" in fieldValues) {
    if (!fieldValues.gender) {
      errors.gender = "Gender is required";
    }
  }

  // Date of Birth: required
  if ("date_of_birth" in fieldValues) {
    if (!fieldValues.date_of_birth) {
      errors.date_of_birth = "Date of birth is required";
    }
  }

  // App ID: required
  if ("app_id" in fieldValues) {
    if (!fieldValues.app_id && !fieldValues.isHost) {
      errors.app_id = "App ID is required";
    }
  }

  // Password: required + minimum length
  // if ("password" in fieldValues) {
  //   if (!fieldValues.password) {
  //     errors.password = "Password is required";
  //   } else if (fieldValues.password.length < 6) {
  //     errors.password = "Password must be at least 6 characters long";
  //   }
  // }

  // App Name: required
  if ("app_name" in fieldValues) {
    if (!fieldValues.app_name.trim() && !fieldValues.isHost) {
      errors.app_name = "App name is required";
    }
  }

  // App URL: required + valid URL
  if ("app_url" in fieldValues) {
    const httpRegex = /^https?:\/\/(?:www\.)?[\w.-]+\.[a-z]{2,}(?:[\/?#]\S*)?$/i;
    if (!fieldValues.app_url.trim()) {
      errors.app_url = "App URL is required";
    } else if (!httpRegex.test(fieldValues.app_url)) {
      errors.app_url = "App URL is not valid";
    }
  }

  // Payment Method: required
  // if ("payment_method" in fieldValues) {
  //   if (!fieldValues.payment_method) {
  //     errors.payment_method = "Payment method is required";
  //   }
  // }

  return errors;
}


export function formatDuration(ms) {
  const seconds = Math.floor(ms / 1000);
  const minutes = Math.floor(ms / 60000);
  const hours = Math.floor(ms / 3600000);
  const days = Math.floor(ms / 86400000);

  if (days > 0) return `${days} day${days > 1 ? "s" : ""} ago`;
  if (hours > 0) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  if (minutes > 0) return `${minutes} min${minutes > 1 ? "s" : ""} ago`;
  return `${seconds} sec${seconds !== 1 ? "s" : ""} ago`;
}

export async function copyText(text) {
  if (navigator.clipboard) {
    await navigator.clipboard.writeText(text);
  } else {
    // Fallback
    const tmp = document.createElement('textarea');
    tmp.value = text;
    document.body.appendChild(tmp);
    tmp.select();
    document.execCommand('copy');
    document.body.removeChild(tmp);
  }
}
export function isValidDate(d) {
  const date = new Date(d);
  return !Number.isNaN(date.getTime());
}